import * as actionType from './action-type'

export const setEditingTextNumber = (number) => {
  return {
    type: actionType.SET_EDITING_TEXT_NUMBER,
    payload: { editingTextNumber: number }
  }
}
